export default "__VITE_ASSET__CKNRIhud__"